import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3zvyk2yn8q: FaireBrandEntity = {
  token: "b_3zvyk2yn8q",
  type: "brand",
  name: "Little Trendy",
  avatarUrl:
    "https://cdn.faire.com/fastly/f8e0cc36a2a1eeed920475abb166577d7d7f51dde64489af4b00eded02f0b252.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/52ef63a28ce2c42b087ed5b649fda6c485cc881722af71081d63dfc7780b2d18.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f8e0cc36a2a1eeed920475abb166577d7d7f51dde64489af4b00eded02f0b252.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/52ef63a28ce2c42b087ed5b649fda6c485cc881722af71081d63dfc7780b2d18.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 508,
  isTopShop: true,
  isInsider: false,
  description:
    "Little Trendy’s delightful clothing line combines the cuties your little fashionista loves with the easy-wear styles you favor. We make today’s top trendy at affordable price. Our awesomely talented design Team in Southern California has fun dreaming, creating, and providing you with the most beautiful and unique collections for your Little sunshine.  As a brand, we are always evolving with the trends and market demand, all while keeping an effortlessly cool vibe.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:20.310Z",
    importedBy: "entity-db-cli",
  },
};
